import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class SettingsEmailsTemplatesIndexRoute extends Route {
  @service router;

  async redirect(model) {
    const { mailerTemplate, mailerTemplateVersionsByCompany, mailerTemplateVersionsByLocation } = model;

    const mailerTemplateVersion =
      mailerTemplateVersionsByCompany.firstObject || mailerTemplateVersionsByLocation.firstObject;

    this.router.replaceWith('visitors.settings.emails.templates.versions', mailerTemplate.id, mailerTemplateVersion.id);
  }
}
